import translationEn from './en/translationEn.json'
import translationAr from './ar/translationAr.json'
import * as Constants from "../constants/Constants.js";
import * as Helpers from "../global/Helpers";

export function OverrideLocalEn() {

    let local = translationEn;
    switch (localStorage.getItem(Constants.localStorageConstants.company_name)) {
        case "IFS":
            local["orderid"] = "Order ID";
            local["closeprice"] = "Close price";
            local["marketvaluePortfolio"] = "Market value";
            local["mobileNo"] = "Mobile No (971xxxxxxxxxx)";
            local["breakevenPrice"] = "Break-even";
            local["UnUtilizedMarginAmount"] = "Utilized Margin Amount";

            break;
        case "UNITED":
            local["WelcomeMessage"] = "Welcome to UNITED SECURITIES Online Trading Portal";
            local["last"] = "Price";
            local["qty"] = "Shares";
            local["NAV"] = "Value";
            local["breakevenPrice"] = "Breakeven price";
            local["closeprice"] = "Close price";
            local["marketvaluePortfolio"] = "Market value";
            local["profitloss"] = "Profit/Loss";
            local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
            local["sendOtp"] = "Submit";
            local["TradingNumber"] = "MSM Number";
            local["IPO_Authintication"] = "Sell IPO shares";

            break;
        case "GLOBAL":
            local["WelcomeMessage"] = "Welcome to GLOBAL FINANCIAL SECURITIES  Online Trading Portal";
            local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
            local["last"] = "Price";
            local["qty"] = "Shares";
            local["NAV"] = "Value";
            local["breakevenPrice"] = "Breakeven price";
            local["closeprice"] = "Close price";
            local["marketvaluePortfolio"] = "Market value";
            local["profitloss"] = "Profit/Loss";
            local["sendOtp"] = "Submit";
            local["IPO_Authintication"] = "Sell IPO shares";
            break;
        case "ADCB":
            local["WelcomeMessage"] = "Sign in to start trading online";
            break;
        case "ALRAMZ":
            local["mobileNo"] = "Mobile No (971xxxxxxxxxx)";
            break;
        case "CIBC":
            local["WelcomeMessage"] = "Welcome to Mahfazty";
            local["sendOtp"] = "Submit";
            local["otp"] = "Enter Your Second Authentication.";
            local["otpDesc"] = "second password";
            local["validity"] = "Execution Type";
            break;
        case "FSC":
            local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
            local["sendOtp"] = "Verify";
            local["IPO_Authintication"] = "Sell IPO shares";
            break;
        case "UBHAR":
            local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
            local["sendOtp"] = "Submit";
            local["IPO_Authintication"] = "Sell IPO shares";
            break;
        case "HORIZON":
            local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
            local["sendOtp"] = "Submit";
            local["IPO_Authintication"] = "Sell IPO shares";

            break;
        case "AHLI":
            local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
            local["sendOtp"] = "Submit";
            local["IPO_Authintication"] = "Sell IPO shares";

            break;
        case "Vision":
            local["mobileNo"] = "Mobile No (968xxxxxxxxxx)";
            local["sendOtp"] = "Submit";
            local["IPO_Authintication"] = "Sell IPO shares";

            break;


    }
    return local;
}

export function OverrideLocalAr() {
    let local = translationAr;
    switch (localStorage.getItem(Constants.localStorageConstants.company_name)) {
        case "IFS":
            local["orderid"] = "رقم الطلب";
            local["mobileNo"] = "رقم الموبايل (971xxxxxxxxxx)";
            break;
        case "UNITED":
            local["WelcomeMessage"] = "مرحباً بكم في موقع التداول الإلكتروني لشركة المتحدة للأوراق المالية";
            local["last"] = "السعر";
            local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
            local["IPO_Authintication"] = "بيع اسهم االاكتتاب";

            break;
        case "GLOBAL":
            local["WelcomeMessage"] = "مرحباً بكم في موقع التداول الإلكتروني لشركة الدولية للأوراق المالية";
            local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
            local["IPO_Authintication"] = "بيع اسهم االاكتتاب";
            break;
        case "ADCB":
            local["WelcomeMessage"] = "قم بتسجيل الدخول لبدء التداول عبر الإنترنت";
            break;
        case "ALRAMZ":
            local["mobileNo"] = "رقم الموبايل (971xxxxxxxxxx)";
            break;
        case "CIBC":
            local["WelcomeMessage"] = "مرحبا بك في محفظتي";
            local["otp"] = "كلمة المرور الثانية";
            break;
        case "FSC":
            local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";
            local["IPO_Authintication"] = "بيع اسهم االاكتتاب";
            break;
            case "UBHAR":
                local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";   
                local["IPO_Authintication"] = "بيع اسهم االاكتتاب";            
                break;
            case "HORIZON":
                local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";   
                local["IPO_Authintication"] = "بيع اسهم االاكتتاب";           
                break;
            case "AHLI":
                local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";   
                local["IPO_Authintication"] = "بيع اسهم االاكتتاب";           
                break;
            case "Vision":
                local["mobileNo"] = "رقم الموبايل (968xxxxxxxxxx)";     
                local["IPO_Authintication"] = "بيع اسهم االاكتتاب";         
                break;

    }
    return local;
}